import { render, staticRenderFns } from "./WaybillDetail.vue?vue&type=template&id=4b885626&scoped=true&"
import script from "./WaybillDetail.vue?vue&type=script&lang=js&"
export * from "./WaybillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b885626",
  null
  
)

export default component.exports